module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', _vm._g({
    class: ['p-inputtextarea p-inputtext p-component', {
      'p-filled': _vm.filled,
      'p-inputtextarea-resizable ': _vm.autoResize
    }],
    domProps: {
      "value": _vm.value
    }
  }, _vm.listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1f920d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/textarea/Textarea.vue
// module id = 2044
// module chunks = 0